export class BaseEngine {
  _mixinEngine;
  _withoutCheck;
  _fullscreen;
  _groups;
  _removeInCorrects;
  _correctBlock;
  _bruteForce;
  _autoCheckAllCorrect;
  _removeAllFromBadTarget;
  _removeAllForBadCount;
  _rulesGame;
  _layout;
  _preStage;

  constructor(obj) {
    this._mixinEngine = obj.engine;
    this._withoutCheck = true;
    this._fullscreen = false;
    this._removeInCorrects = false;
    this._correctBlock = false;
    this._bruteForce = false;
    this._autoCheckAllCorrect = false;
    this._removeAllFromBadTarget = false;
    this._removeAllForBadCount = false;

    this._rulesGame = {};
    this._layout = {
      groups: [],
    };
  }

  addGroup(indx) {
    let gr = {
      idGroup: indx,
      positions: {
        autoFit: false,
        pos: { width: 100, height: 100, x: 0, y: 0 },
        type: 'absolute',
      },
      background: {
        color: 'rgba(0,0,0,0.3)',
      },
      itemsConfig: {
        background: {
          color: 'rgba(0,0,0,0.3)',
        },
        positions: {
          pos: { x: 0, y: 0 },
        },
      },
      items: [],
    };
    this.layout.groups.push(gr);

    this._preStage.addGroup(gr);
    return gr;
  }

  updateGroup(obj) {
    let gr = this.getGroup(obj.idGroup);
    gr.positions = obj.positions;
    gr.background = obj.background;

    console.log(gr);
    console.log(this._preStage.groups[obj.idGroup]._items);
    for (let i = 0; i < gr.items.length; i++) {
      if (typeof this._preStage.groups[obj.idGroup]._items[gr.items[i].id] == 'undefined') {
        this._preStage.addItem({
          idGroup: obj.idGroup,
          id: gr.items[i].id,
          config: gr.items[i],
          itemsConfig: gr.itemsConfig,
        });
      } else {
        console.log('UPDATE GR: ' + obj.idGroup + ' item: ' + gr.items[i].id);
      }
    }
  }

  getGroup(indx) {
    for (let i in this.layout.groups) {
      if (this.layout.groups[i].idGroup == indx) return this.layout.groups[i];
    }
    return -1;
  }

  removeGroup(indx) {
    let inx = -1;
    for (let i in this.layout.groups) {
      if (this.layout.groups[i].idGroup == indx) {
        inx = i;
        break;
      }
    }

    if (inx > -1) {
      this.layout.groups.splice(inx, 1);
    }
  }

  getConfigGame() {
    if (this.withoutCheck === true) {
      // this.rulesGame.itemsGarbage.splice(0, this.rulesGame.itemsGarbage.length);
      // this.rulesGame.items.splice(0, this.rulesGame.items.length);
      console.log(this.layout.groups);
      for (let i = 0; i < this.layout.groups.length; i++) {
        console.log(this.layout.groups[i]);
        this.rulesGame.itemsGarbage[i] = { idGroup: this.layout.groups[i].idGroup, itemsConfig: { block: false } };
        if (this.layout.groups[i].items.length > 0 && this.rulesGame.items.length == 0) {
          this.rulesGame.items[0] = {
            idGroup: this.layout.groups[i].idGroup,
            idItem: this.layout.groups[i].items[0].id,
          };
        }
      }
      // for (let i = 0; i < this.layout.groups.length; i++) {
      //   this.rulesGame.itemsGarbage.push({ idGroup: this.layout.groups[i].idGroup, itemsConfig: { block: false } });
      //   if (this.layout.groups[i].items.length > 0 && this.rulesGame.items.length == 0) {
      //     this.rulesGame.items.push({
      //       idGroup: this.layout.groups[i].idGroup,
      //       idItem: this.layout.groups[i].items[0].id,
      //     });
      //   }
      // }
    }

    return {
      mixinEngine: this._mixinEngine,
      withoutCheck: this._withoutCheck,
      fullscreen: this._fullscreen,
      cssStyle: {
        top: 0,
        position: 'absolute',
        background: 'white',
        'z-index': 20000,
      },
      configGame: {
        removeInCorrects: this._removeInCorrects,
        correctBlock: this._correctBlock,
        bruteForce: this._bruteForce,
        autoCheckAllCorrect: this._autoCheckAllCorrect,
        removeAllFromBadTarget: this._removeAllFromBadTarget,
        removeAllForBadCount: this._removeAllForBadCount,
        rulesGame: this._rulesGame,
        layout: this._layout,
      },
    };
  }

  printConfigJSON() {
    let json = this.getConfigGame();
    delete json.cssStyle;
    return this._encode(JSON.stringify(json, null, 4));
  }

  _encode(s) {
    var out = [];
    for (var i = 0; i < s.length; i++) {
      out[i] = s.charCodeAt(i);
    }
    return new Uint8Array(out);
  }

  get engine() {
    return this._mixinEngine;
  }

  set withoutCheck(val) {
    this._withoutCheck = val;
  }
  get withoutCheck() {
    return this._withoutCheck;
  }

  set fullscreen(val) {
    this._fullscreen = val;
  }
  get fullscreen() {
    return this._fullscreen;
  }

  set removeInCorrects(val) {
    this._removeInCorrects = val;
  }
  get removeInCorrects() {
    return this._removeInCorrects;
  }

  set correctBlock(val) {
    this._correctBlock = val;
  }
  get correctBlock() {
    return this._correctBlock;
  }

  set bruteForce(val) {
    this._bruteForce = val;
  }
  get bruteForce() {
    return this._bruteForce;
  }

  set autoCheckAllCorrect(val) {
    this._autoCheckAllCorrect = val;
  }
  get autoCheckAllCorrect() {
    return this._autoCheckAllCorrect;
  }

  set removeAllFromBadTarget(val) {
    this._removeAllFromBadTarget = val;
  }
  get removeAllFromBadTarget() {
    return this._removeAllFromBadTarget;
  }

  set removeAllForBadCount(val) {
    this._removeAllForBadCount = val;
  }
  get removeAllForBadCount() {
    return this._removeAllForBadCount;
  }

  set rulesGame(val) {
    this._rulesGame = val;
  }
  get rulesGame() {
    return this._rulesGame;
  }

  set layout(val) {
    this._layout = val;
  }
  get layout() {
    return this._layout;
  }
}
